import { apiGet } from './client'
import { API_ENDPOINTS } from '@/shared/config'
import type { StatsData } from '@/shared/types'

export const statsApi = {
  get() {
    return apiGet<StatsData>(API_ENDPOINTS.STATS)
  },
}
